import {useTranslation} from "react-i18next";
import Divider from "antd/es/divider";
import React, {useEffect, useState} from "react";
import Icon from "./Icon";
import CloseOutlined from "@ant-design/icons/lib/icons/CloseOutlined";
import StopOutlined from "@ant-design/icons/lib/icons/StopOutlined";


export default (prop) => {

    const { t } = useTranslation()

    useEffect(() => {

    }, [])

    return (<>

        <ul>
            {
                prop.data ? prop.data.map((id, index) => {

                    if (id === 0) {
                        return <li key={index}>
                            <div className={`bpSimHeroItem2`}>
                                <Icon type={'hero'} name={52} size={40} />
                            </div>
                        </li>
                    } else {
                        return <li key={id}>
                            <div onClick={() => {
                                if (prop.remove) {
                                    prop.remove(id)
                                }
                            }} key={id} className={`bpSimHeroItem${prop.stateIds[id].level}`}>

                                <Icon type={'hero'} name={id} size={40} />
                                {
                                    prop.stateIds[id].ban ? <div style={{ position: 'relative' }}>
                                        <StopOutlined height={40} width={40} style={{ color: '#cf1322', fontSize: "40px", position: "absolute", bottom: 0, left: 0 }} />
                                    </div> : null
                                }
                            </div>

                        </li>
                    }

                }) : null
            }
        </ul>


    </>)

}
